import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';


function Label () {
  return (
    <>
      <span>View in 3D</span>
      <svg className='structure-dialog--header-title-icon'>
        <use xlinkHref='#icon-retweet'/>
      </svg>
    </>
  );
}

export default function SwitcherTo3D (props) {
 const { setEditorView, editorView } = props;

 return (
    <Button
      onClick={() => {
        setEditorView(!editorView);
      }}
      buttonConfig={{
        e2eName: '3d-switcher',
        label: <Label />,
        type: 'primary-alt',
      }}
    />
 );
}

SwitcherTo3D.propTypes = {
  setEditorView: PropTypes.func.isRequired,
  editorView: PropTypes.bool.isRequired,
};
